import { render, staticRenderFns } from "./customSelf.vue?vue&type=template&id=198906fa&scoped=true&"
import script from "./customSelf.vue?vue&type=script&lang=ts&"
export * from "./customSelf.vue?vue&type=script&lang=ts&"
import style0 from "./customSelf.vue?vue&type=style&index=0&id=198906fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198906fa",
  null
  
)

export default component.exports